import React from 'react'; 

export default class MyPopup extends React.Component {
    
    constructor(props){
        super(props);
    }

    componentDidMount(){
        setTimeout(()=>{
            this.props.onTimeout()
        }, this.props.secs || 3000)
    }

    render(){
        return <div     
        style={
            {
                position:'absolute',
                top:'2%',
                left:'46%',
                zIndex:60000,
                padding:'1%',
                borderRadius:'4%',
                opacity:'90%',
                backgroundColor:this.props.snak.succes ? 'green' : 'red',
                color:'white'
            }
        }
    >
        <span> 
            {this.props.snak.msg || ''}
        </span>
    </div>
    }

};